import { createContext, useContext } from 'react';
export const ModalContext = createContext({
    id: '',
    open: false,
    showCloseBtn: true,
    showZenModeBtn: false,
    zenMode: false,
    onClose: undefined,
    toggleZenMode: undefined,
});
export const useModalContext = () => useContext(ModalContext);
//# sourceMappingURL=ModalContext.js.map